import { RoutePathsType } from "../types/routePaths";

export const RoutePaths: RoutePathsType = {
  NavBar: {
    primaryLinks: [
      {
        name: "FASHION",
        url: "/fashion",
      },
      {
        name: "CULTURE",
        url: "/culture",
      },
      {
        name: "BEAUTY",
        url: "/beauty",
      },
      {
        name: "WATCHES AND JEWELLERY",
        url: "/watches-and-jewellery",
      },
      {
        name: "PEOPLE CAM",
        url: "/topics/people-cam",
      },
      { name: "PARTIES", url: "/topics/parties" },
    ],
    utilityLinks: [
      // {
      //   id: "magazineIssues", // allow overwrite of name and url from data
      //   name: "Subscribe",
      //   url: "https://subscribe.sph.com.sg/package/subscribe-female-singapore/",
      //   as: "button",
      //   variant: "primary",
      //   target: "_blank",
      // },
    ],
    searchBarLink: {
      as: "popup",
      name: "Search",
      url: "/search",
    },

    mobileUtilityLinks: {
      // login: {
      //   name: "Login",
      //   url: "/",
      // },
    },
  },
  Footer: [
    // make sure to update following css grid token if changing the number of items
    // --header-mega-menu-footer-items-grid-template
    {
      text: "ABOUT US",
      url: "/about-us",
    },
    {
      text: "ADVERTISE WITH US",
      url: "https://www.sph.com.sg/advertising-solutions/",
      target: "_blank",
    },
    {
      text: "CONTACT US",
      url: "https://www.sph.com.sg/contact-us/",
      target: "_blank",
    },
    {
      text: "CONDITIONS OF ACCESS",
      url: "https://www.sph.com.sg/legal/website_tnc/",
      target: "_blank",
    },
    {
      text: "PDPA",
      url: "https://www.sph.com.sg/legal/pdpa/",
      target: "_blank",
    },
    {
      text: "PRIVACY POLICY",
      url: "https://www.sph.com.sg/legal/sph_privacy/",
      target: "_blank",
    },
  ],
  MegaMenu: [
    {
      text: "FASHION",
      url: "/fashion",
      placement: "left",
      subMenu: [
        {
          text: "FASHION NEWS",
          url: "/tag/fashion-news",
          hideInMegaMenu: true,
        },
        {
          text: "SHOPPING",
          url: "/tag/shopping",
          hideInMegaMenu: true,
        },
        {
          text: "STREET STYLE",
          url: "/tag/street-style",
          hideInMegaMenu: true,
        },
      ],
    },
    {
      text: "CULTURE",
      url: "/culture",
      placement: "left",
      subMenu: [
        {
          text: "FEATURES",
          url: "/tag/features",
          hideInMegaMenu: true,
        },
        {
          text: "ADULTING",
          url: "/tag/adulting",
          hideInMegaMenu: true,
        },
        {
          text: "FINANCE",
          url: "/tag/finance",
          hideInMegaMenu: true,
        },
        {
          text: "THINGS TO DO",
          url: "/tag/things-to-do",
          hideInMegaMenu: true,
        },
        {
          text: "DINING",
          url: "/tag/dining",
          hideInMegaMenu: true,
        },
        {
          text: "TRAVEL",
          url: "/tag/travel",
          hideInMegaMenu: true,
        },
        {
          text: "ART",
          url: "/tag/art",
          hideInMegaMenu: true,
        },
        {
          text: "FILM & MUSIC",
          url: "/tag/film-and-music",
          hideInMegaMenu: true,
        },
        {
          text: "PARTIES & RAVES",
          url: "/tag/parties-and-raves",
          hideInMegaMenu: true,
        },
        {
          text: "SUSTAINABILITY",
          url: "/tag/sustainability",
          hideInMegaMenu: true,
        },
      ],
    },
    {
      text: "BEAUTY",
      url: "/beauty",
      placement: "left",
      subMenu: [
        {
          text: "BEAUTY NEWS",
          url: "/tag/beauty-news",
          hideInMegaMenu: true,
        },
        {
          text: "MAKE UP",
          url: "/tag/makeup",
          hideInMegaMenu: true,
        },
        {
          text: "SKINCARE",
          url: "/tag/skincare",
          hideInMegaMenu: true,
        },
        {
          text: "PERFUME",
          url: "/tag/perfume",
          hideInMegaMenu: true,
        },
      ],
    },
    {
      text: "WATCHES & JEWELLERY",
      url: "/watches-and-jewellery",
      placement: "left",
      subMenu: [
        {
          text: "FINE JEWELLERY",
          url: "/tag/fine-jewellery",
          hideInMegaMenu: true,
        },
        {
          text: "WATCHES",
          url: "/tag/watches",
          hideInMegaMenu: true,
        },
      ],
    },
    {
      text: "PEOPLE CAM",
      url: "/topics/people-cam",
      placement: "left",
    },
    {
      text: "PARTIES",
      url: "/topics/parties",
      placement: "left",
    },
  ],
};
